import * as React from 'react'
import { useForm } from 'react-hook-form'
import { Button, Col, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { SaveButton } from '@hyper/button'
import { useNotificationHook } from '@hyper/use-notification-hook'
import { RootState, useAppDispatch, useAppSelector } from '@store/index'
import { useFormRequest } from '@components/hooks/use-api-request'
import { CmsResortDetails, ResortAttraction } from '@modules/cms/models'
import { FormInput, FormPlain } from '@hyper/forms'
import { createAttraction, updateAttraction } from '@api/cms'
import { FileUploader, UploaderAcceptableFile } from '@components/file-uploader'
import { BaseModalProps } from '@components/modals/types'
import { setCmsResort } from '@store/slices/cms-reservation-app-slice'
import { Form } from '@hyper/forms/form'

interface Props extends BaseModalProps {
  attraction?: ResortAttraction
  resort: CmsResortDetails
}

export interface FormInputs {
  title: string
  subtitle: string
}

export const CmsReservationAppAttractionModal: React.FC<Props> = ({ toggleIsVisible, attraction, resort }) => {
  const methods = useForm<FormInputs>({
    defaultValues: attraction,
  })
  const dispatch = useAppDispatch()
  const [image, setImage] = React.useState()
  const { addSuccessMessage } = useNotificationHook()
  const url = useAppSelector((state: RootState) => state.appState.appData.urls.cms.resorts_attractions)

  const { isLoading, action: onSubmit } = useFormRequest(async (payload: FormInputs) => {
    const resortDetails = await (!attraction
      ? createAttraction(url, { ...payload, resort: resort.id, image })
      : updateAttraction(attraction.urls.details, { ...payload, image }))

    addSuccessMessage('Sukces', !attraction ? 'Wpis został dodany' : 'Wpis został zmieniony')
    dispatch(setCmsResort(resortDetails))
    toggleIsVisible()
  }, methods.setError)

  const upload = file => setImage(file)

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <ModalHeader toggle={toggleIsVisible}>
        {!attraction ? (
          'Dodaj wpis'
        ) : (
          <>
            Edytuj wpis <span className="text-semi-strong">{attraction.title}</span>
          </>
        )}
      </ModalHeader>
      <ModalBody>
        <Row>
          <FormInput label="Nazwa" name="title" />
          <FormInput label="Krótki opis" name="subtitle" />
          {(image || attraction?.image) && (
            <FormPlain name="image">
              <label>Aktualne zdjęcie:</label>
              <div className="mt-1">
                <img src={image ? URL.createObjectURL(image) : attraction?.image} className="avatar-xl img-thumbnail" />
              </div>
            </FormPlain>
          )}
          <Col md={12}>
            <FileUploader
              isLoading={isLoading}
              upload={upload}
              file={image}
              accept={UploaderAcceptableFile.Images}
              maxFiles={1}
              label="Przeciągnij i upuść zdjęcie lub kliknij by dodać zdjęcie"
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="light" type="button" onClick={toggleIsVisible}>
          Zamknij
        </Button>

        <SaveButton className="btn btn-green" isSaving={isLoading} />
      </ModalFooter>
    </Form>
  )
}
